import merge from 'lodash/merge'

export default {
  save({ state, getters, dispatch, rootGetters }) {
    const mergeData = merge({}, rootGetters['blob/get']('concilio--site-settings'), {
      cookiebar: merge({}, getters.defaultSettings, getters.currentSettings)
    })

    mergeData.cookiebar.preview = false

    return dispatch('blob/save', {
      blobID: 'concilio--site-settings',
      blobData: mergeData
    },
    { root: true })
  },
  init({ state, getters, commit }) {
    const settings = merge({}, getters.defaultSettings, getters.settingsBlob)
    commit('UPDATE_SETTINGS', settings)
  },
  update({ state, commit }, payload) {
    commit('UPDATE_SETTINGS', payload)
  },
  activatePreviewMode({ commit }) { commit('SET_PREVIEW_MODE', true) },
  deactivatePreviewMode({ commit }) {
    commit('SET_PREVIEW_MODE', false)
  }
}
